import { render } from "./IndexTableRow.vue?vue&type=template&id=60a1da40"
import script from "./IndexTableRow.vue?vue&type=script&lang=js"
export * from "./IndexTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__